import { css, withTheme } from 'styled-components'
import Text from './Text'
import { height, borderRadius, border, display, fontSize } from 'styled-system'

const getSizeAttributes = props => {
  switch (props.size) {
    case 'sm':
      return {
        height: props.mini ? '30px' : [2, 1]
      }
    case 'large':
      return {
        height: props.mini ? '30px' : [4, 3]
      }
    default:
      return {
        height: props.mini ? '30px' : [3, 2]
      }
  }
}

const NumberPicker = withTheme(props => {
  const sizeProps = getSizeAttributes(props)
  return (
    <Text
      {...sizeProps}
      requiredColor={'rgba(235, 81, 96, 0.8)'}
      as='input'
      type='number'
      css={[
        props => css`
          &::-webkit-inner-spin-button {
            opacity: 1;
            -webkit-appearance: none;
            -moz-appearance: none;
            cursor: pointer;
            display: block;
            color: #333;
            background: #eee url('./img/arrow-input-number.png') no-repeat 50% 50%;
            /* background-size: 19px; */
            background-size: 19px;
            right: -1px;
            box-shadow: 1px 0 0 0 #d5d6d7 inset;
            padding: 4px;
            position: relative;
            height: 45px;
            width: 10px;
          }
          @media (min-width: ${props.theme.breakpoints[0]}px) {
            &::-webkit-inner-spin-button {
              width: 8px;
              background-size: 17px;
            }
          }
        `,
        height,
        border,
        display,
        borderRadius,
        fontSize
      ]}
      {...props}
    />
  )
})

NumberPicker.defaultProps = {
  color: 'grey.0',
  bg: 'white.default',
  border: 'grey.2',
  borderRadius: 1,
  // fontSize: ['l', 's']
  fontSize: 's'
}

export default NumberPicker
